/**
 * API-Client für /api/dashboard — rollenabhängige Startseite (Design-Canvas
 * "ShiftSync Rollenansichten": Main.dc.html = Chef, Filialleitung.dc.html =
 * Filialleitung). Siehe backend/src/routes/dashboard.ts für die genaue
 * Rechte-/Sichtbarkeits-Logik je Feld.
 */

import { apiFetch } from './api';

export interface DashboardOwnerLocation {
  id: string;
  name: string;
  branchNumber: string | null;
  address: string | null;
  color: string;
  isActive: boolean;
  employeeCount: number;
  hoursThisWeek: number;
  openVacationRequests: number;
}

export interface DashboardOwnerData {
  role: 'owner';
  stats: { locationsCount: number; employeesCount: number; openVacationRequests: number };
  pendingAdvancesCount: number;
  locations: DashboardOwnerLocation[];
  unassignedVacationRequests: number;
}

export interface DashboardTeamRow {
  userId: string;
  name: string;
  hours: number;
  /** null = für diesen Standort nicht freigegeben (managerCanSeeWages=false). */
  wage: number | null;
}

export interface DashboardEinspringenRow {
  userId: string;
  name: string;
  /** Name des Haupt-Standorts, falls abweichend von diesem Standort. null = derselbe oder unbekannt. */
  homeLocationName: string | null;
  /** Nachtrag 11.09.2026: true = Person ist an diesem Standort nicht fest zugeordnet (echter Einsprung). */
  isForeign: boolean;
  /** Nachtrag 11.09.2026: Zusatzstunden warten auf die Chef-Entscheidung (ohne Anzahl — immer geliefert). */
  bonusPending: boolean;
  date: string;
  startTime: string;
  endTime: string;
  /** null = für diesen Standort nicht freigegeben (managerCanSeeBonusHours=false). */
  bonusHours: number | null;
  bonusStatus: 'none' | 'pending' | 'approved' | 'rejected' | null;
}

export interface DashboardManagerLocation {
  id: string;
  name: string;
  /** Nachtrag 08.09.2026 — für die optische Unterscheidung mehrerer gestapelter Standort-Blöcke (Bereichsleitung). */
  color: string;
  branchNumber: string | null;
  employeeCount: number;
  wageVisible: boolean;
  bonusVisible: boolean;
  team: DashboardTeamRow[];
  einspringen: DashboardEinspringenRow[];
}

export interface DashboardManagerData {
  role: 'manager';
  isBereichsleiter: boolean;
  stats: { employeeCount: number; hoursThisWeek: number; openVacationRequests: number };
  locations: DashboardManagerLocation[];
}

export interface DashboardNoneData {
  role: 'none';
}

export type DashboardData = DashboardOwnerData | DashboardManagerData | DashboardNoneData;

export const dashboardApi = {
  get: (token: string) => apiFetch<DashboardData>('/api/dashboard', { token }),
};
